import { EMAIL_VALIDATION_REGEX } from 'common/util/validations';


export const userInputValidationRules = {
    required: {
        value: true,
        message: 'This field is required.'
    },
    maxLength: {
        value: 50,
        message: 'Maximum length is 50 characters'
    },
    emailPattern: {
        value: new RegExp(EMAIL_VALIDATION_REGEX),
        message: 'The field is an invalid email address'
    }
}
